var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.5C6.54801 7.5 6.09602 7.3588 5.71047 7.07266L0 2.84375V8.75C0 9.4401 0.587617 10 1.3125 10H12.6875C13.4124 10 14 9.44036 14 8.75V2.84375L8.29063 7.07552C7.90508 7.35938 7.45117 7.5 7 7.5ZM0.44543 2.11719L6.24777 6.41667C6.69047 6.74479 7.31062 6.74479 7.75332 6.41667L13.5557 2.11719C13.8113 1.90885 14 1.58854 14 1.25C14 0.559635 13.4121 0 12.6875 0H1.3125C0.587617 0 0 0.559635 0 1.25C0 1.58854 0.164336 1.90885 0.44543 2.11719Z",
    fill: "#C1C5CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.db621d39.svg";
export { ForwardRef as ReactComponent };